<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>View Receipt</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabsNav">
              <v-tab @click.native="doValidateMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doValidateMandatory(1)">Optional</v-tab>
              <v-tab @click.native="doValidateMandatory(2)">Payment Method</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabsNav">
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
                <form data-vv-scope="receiptsMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.branch }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="mulAcctRcptLabel.docAE" v-model="mulAcctRcptForm.docAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.documentNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.documentNo }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.transactionDateDisp }}</v-subheader>
                              <div class="queryValue">{{ convertDate(mulAcctRcptForm.transactionDateDisp) }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.depositAcct }}</v-subheader>
                              <div class="queryValue" v-for="item in filterDepositAcctList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md1 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.fund }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFundList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.paymentMethod }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPaymentMethodList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.gstIO }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstIOList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.gstStatus }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstStatList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.gstRate }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.gstRate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.receivedFrom }}</v-subheader>
                              <div class="queryValue" v-for="item in filterReceivedFromList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.accountNoSuffixDesc }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAcctNoSuffixList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.amountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.amountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.amount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.amount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.gstAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.gstAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" v-model="mulAcctRcptForm.gstAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.gstAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.gstAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.netAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.netAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.netAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.netAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.bankAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" v-model="mulAcctRcptForm.bankAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.bankAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankChargesCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.bankChargesCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankCharges }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.bankCharges }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankTotalAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.bankTotalAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankTotalAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.bankTotalAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankTotalLocalCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctRcptForm.bankTotalLocalCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" v-model="mulAcctRcptForm.bankTotalLocalAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.bankTotalLocal }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.bankTotalLocal }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.createdBy + ' on ' + mulAcctRcptForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.modifiedBy + ' on ' + mulAcctRcptForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional">
                <form data-vv-scope="receiptsOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.printDocument }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPrintDocOptList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.addressTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.policyNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.policyNo }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.companyName }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.companyName }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.docAddress1 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.docAddress1 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.docAddress2 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.docAddress2 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.docAddress3 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.docAddress3 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.docAddress4 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.docAddress4 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.postalCode }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.postalCode }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.details }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.details }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-textarea
                                v-model="mulAcctRcptForm.statementRef"
                                :label="mulAcctRcptLabel.statementRef"
                                disabled
                                no-resize
                                rows="3"
                              ></v-textarea>
                            </v-flex>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.department }}</v-subheader>
                              <div class="queryValue" v-for="item in filterDepartmentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.insuredName }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.insuredName }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.claimNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.claimNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.taxInvoiceNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.taxInvoiceNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="paymentmethod">
                <form data-vv-scope="receiptsPaymentForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.payerBank }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPayerBankList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.payersChequeNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.payersChequeNo }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.drawerName }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.drawerName }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctRcptLabel.creditCardNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctRcptForm.creditCardNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-flex xs12 class="mt-3">
              <v-card>
                <v-data-table
                  v-bind:headers="listMulAcctRcptHeaders"
                  v-bind:items="accountList"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectAcctRcptColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3><u>Grand Total </u></h3>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.payment"
                          :label="grandTotLabel.payment"
                          disabled
                          :error-messages="errors.collect('grandTotForm.payment')"
                          data-vv-name="grandTotForm.payment"
                          :data-vv-as="grandTotLabel.payment"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.gst"
                          :label="grandTotLabel.gst"
                          disabled
                          :error-messages="errors.collect('grandTotForm.gst')"
                          data-vv-name="grandTotForm.gst"
                          :data-vv-as="grandTotLabel.gst"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.net"
                          :label="grandTotLabel.net"
                          disabled
                          :error-messages="errors.collect('grandTotForm.net')"
                          data-vv-name="grandTotForm.net"
                          :data-vv-as="grandTotLabel.net"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.bankAmt"
                          :label="grandTotLabel.bankAmt"
                          disabled
                          :error-messages="errors.collect('grandTotForm.bankAmt')"
                          data-vv-name="grandTotForm.bankAmt"
                          :data-vv-as="grandTotLabel.bankAmt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.charges"
                          :label="grandTotLabel.charges"
                          disabled
                          :error-messages="errors.collect('grandTotForm.charges')"
                          data-vv-name="grandTotForm.charges"
                          :data-vv-as="grandTotLabel.charges"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.total"
                          :label="grandTotLabel.total"
                          disabled
                          :error-messages="errors.collect('grandTotForm.total')"
                          data-vv-name="grandTotForm.total"
                          :data-vv-as="grandTotLabel.total"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.localTotal"
                          :label="grandTotLabel.localTotal"
                          disabled
                          :error-messages="errors.collect('grandTotForm.localTotal')"
                          data-vv-name="grandTotForm.localTotal"
                          :data-vv-as="grandTotLabel.localTotal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-flex>
          </v-card>
        </v-flex>
        <v-dialog v-model="showErrorDialog" width="800px">
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-information</v-icon>
              <v-toolbar-title>System Information</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <div v-if="messages.length > 0" class="pb-3">
                <span class="info-dialog-msg-header">Oops something went wrong...</span>
                <v-spacer class="mt-2"></v-spacer>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                    {{ error.message }}
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { mulAcctReceiptViewMixin } from '@/mixins/accounting/receipts/mulAcctRcpt/mulAcctReceiptViewMixin'
import { mulAcctReceiptAjaxMixin } from '@/mixins/accounting/receipts/mulAcctRcpt/mulAcctReceiptAjaxMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
import * as TableConst from '@/mixins/table'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'

export default {
  data() {
    return {
      receiptTabs: ['Mandatory', 'Optional', 'Payment Method'],
      tabsNav: 0,
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      branches: [],
      currencies: [],
      payerbanks: [],
      paymentmethods: [],
      departments: [],
      cashbooks: [],
      miscacctparams: [],
      paymentmethod: {},
      amountcurrencies: [],
      amountcurrencydata: {},
      trandaterange: {},
      gstStatuses: [],
      gstrate: '0.00',
      gstIOOptions: [
        { value: 'B', label: '' },
        { value: 'I', label: 'Input' },
        { value: 'O', label: 'Output' }
      ],
      printDocOptions: [
        { value: 'I', label: 'Immediately' },
        { value: 'L', label: 'Later' },
        { value: 'N', label: 'No' }
      ],
      addressToOptions: [
        { value: 'A', label: 'Agent' },
        { value: 'I', label: 'Insured' },
        { value: 'E', label: 'Entered as below' }
      ],
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now',
        matchLater: 'Match Later',
        matchRBC: 'Match RBC'
      },
      validStatus: {
        mandatory: true,
        optional: true,
        paymentmethod: true
      },
      receiptErrors: [],
      promptConfirmation: false,
      isExistChequeNo: false,
      actionName: null,
      banks: [],
      acctnosuffixes: [],
      accounts: [],
      funds: [],
      grandTotLabel: {
        payment: 'Payment',
        gst: 'GST',
        net: 'Net',
        bankAmt: 'Bank Amt',
        charges: 'Charges',
        total: 'Total',
        localTotal: 'Local Total'
      },
      grandTotForm: {
        payment: '0.00',
        gst: '0.00',
        net: '0.00',
        bankAmt: '0.00',
        charges: '0.00',
        total: '0.00',
        localTotal: '0.00'
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    receiptData() {
      return this.$store.state.receipt.receiptData
    },
    displayErrorDialog() {
      return this.messages
    },
    filterBranchList() {
      return this.branches.filter((list) => {
        return list.value === this.mulAcctRcptForm.branch
      })
    },
    filterReceivedFromList() {
      return this.accounts.filter((list) => {
        return list.value === this.mulAcctRcptForm.receivedFrom
      })
    },
    filterDepositAcctList() {
      return this.banks.filter((list) => {
        return list.value === this.mulAcctRcptForm.depositAcct
      })
    },
    filterAcctNoSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.mulAcctRcptForm.accountNoSuffixDesc
      })
    },
    filterPaymentMethodList() {
      return this.paymentmethods.filter((list) => {
        return list.value === this.mulAcctRcptForm.paymentMethod
      })
    },
    filterGstIOList() {
      return this.gstIOOptions.filter((list) => {
        return list.value === this.mulAcctRcptForm.gstIO
      })
    },
    filterGstStatList() {
      return this.gstStatuses.filter((list) => {
        return list.value === this.mulAcctRcptForm.gstStatus
      })
    },
    filterAmountCurrList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.mulAcctRcptForm.amountCurr
      })
    },
    filterPrintDocOptList() {
      return this.printDocOptions.filter((list) => {
        return list.value === this.mulAcctRcptForm.printDocument
      })
    },
    filterAddressToList() {
      return this.addressToOptions.filter((list) => {
        return list.value === this.mulAcctRcptForm.addressTo
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.mulAcctRcptForm.department
      })
    },
    filterPayerBankList() {
      return this.payerbanks.filter((list) => {
        return list.value === this.mulAcctRcptForm.payerBank
      })
    },
    filterFundList() {
      return this.funds.filter((list) => {
        return list.value === this.mulAcctRcptForm.fund
      })
    },
    listMulAcctRcptHeaders() {
      let result = []
      for (const selectAcctRcptColumns of this.selectAcctRcptColumns) {
        let findCol = this.mulAcctRcptColumns.find((a) => selectAcctRcptColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  methods: {
    doValidateMandatory(tabId) {
      if (tabId === 1) {
        this.validStatus.mandatory = true
        this.tabsNav = tabId
      } else if (tabId === 2) {
        this.validStatus.optional = true
        this.tabsNav = tabId
      } else if (tabId === 3) {
      }
    },
    defaultAmount() {
      return (0.0).toFixed(2)
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    filterCurrList(curr) {
      const data = this.currencies.find(list => list.value === curr)
      return data ? data.label : ''
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('receiptInit')])
      this.getCommonData('miscacctparams')
      this.fetchBranch()
      this.fetchFund()
      this.fetchCurrency()
      this.fetchPayerBank()
      this.fetchPaymentMethod()
      this.fetchDepartment()
      this.fetchCashBook()
      this.fetchAmountCurrency()
      this.fetchGstStatus()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchAccount()
      await Promise.all([this.performReviewMultAcctRcpt()])
    },
    async doQuery(data) {
      this.mulAcctRcptForm.branch = data.branch
      this.mulAcctRcptForm.accountNo = data.accountNo
      this.mulAcctRcptForm.documentNo = data.documentNo
      this.mulAcctRcptForm.docAE = data.docAE === 'true' || data.docAE === true
      this.mulAcctRcptForm.documentNoDisabled = data.documentNoDisabled
      this.mulAcctRcptForm.transactionType = data.transactionType
      this.mulAcctRcptForm.fund = data.fund
      this.mulAcctRcptForm.accountNoSuffix = data.accountNoSuffix
      this.mulAcctRcptForm.accountNoSuffixDesc = data.accountNoSuffixDesc
      this.mulAcctRcptForm.transactionDate = data.transactionDate
      this.mulAcctRcptForm.transactionDateDisp = data.transactionDateDisp
      this.mulAcctRcptForm.receivedFrom = data.receivedFrom
      this.mulAcctRcptForm.depositAcct = data.depositAcct
      this.mulAcctRcptForm.bankNo = data.bankNo
      this.mulAcctRcptForm.paymentMethod = data.paymentMethod
      this.mulAcctRcptForm.cashBook = data.cashBook
      this.mulAcctRcptForm.gstIO = data.gstIO
      this.mulAcctRcptForm.gstStatus = data.gstStatus
      this.mulAcctRcptForm.gstRate = data.gstRate
      this.mulAcctRcptForm.currency = data.currency
      this.mulAcctRcptForm.amount = data.amount
      this.mulAcctRcptForm.gstAmount = data.gstAmount
      this.mulAcctRcptForm.gstAmountAE = data.gstAmountAE === 'A'
      this.mulAcctRcptForm.netAmount = data.netAmount
      this.mulAcctRcptForm.bankAmount = data.bankAmount
      this.mulAcctRcptForm.bankAmountAE = data.bankAmountAE === 'A'
      this.mulAcctRcptForm.bankCharges = data.bankCharges
      this.mulAcctRcptForm.bankTotalAmount = data.bankTotalAmount
      this.mulAcctRcptForm.bankTotalLocal = data.bankTotalLocal
      this.mulAcctRcptForm.bankTotalLocalAE = data.bankTotalLocalAE === 'A'
      this.mulAcctRcptForm.amountCurr = data.amountCurr
      this.mulAcctRcptForm.gstAmountCurr = data.gstAmountCurr
      this.mulAcctRcptForm.netAmountCurr = data.netAmountCurr
      this.mulAcctRcptForm.bankAmountCurr = data.bankAmountCurr
      this.mulAcctRcptForm.bankChargesCurr = data.bankChargesCurr
      this.mulAcctRcptForm.bankTotalAmountCurr = data.bankTotalAmountCurr
      this.mulAcctRcptForm.bankTotalLocalCurr = data.bankTotalLocalCurr
      this.mulAcctRcptForm.printDocument = data.printDocument
      this.mulAcctRcptForm.addressTo = data.addressTo
      this.mulAcctRcptForm.policyNo = data.policyNo
      this.mulAcctRcptForm.companyName = data.companyName
      this.mulAcctRcptForm.docAddress1 = data.docAddress1
      this.mulAcctRcptForm.docAddress2 = data.docAddress2
      this.mulAcctRcptForm.docAddress3 = data.docAddress3
      this.mulAcctRcptForm.docAddress4 = data.docAddress4
      this.mulAcctRcptForm.postalCode = data.postalCode
      this.mulAcctRcptForm.details = data.details
      this.mulAcctRcptForm.statementRef = data.statementRef
      this.mulAcctRcptForm.department = data.department
      this.mulAcctRcptForm.insuredName = data.insuredName
      this.mulAcctRcptForm.claimNo = data.claimNo
      this.mulAcctRcptForm.gstRegNo = data.gstRegNo
      this.mulAcctRcptForm.taxInvoiceNo = data.taxInvoiceNo
      this.mulAcctRcptForm.payerBank = data.payerBank
      this.mulAcctRcptForm.payersChequeNo = data.payersChequeNo
      this.mulAcctRcptForm.drawerName = data.drawerName
      this.mulAcctRcptForm.creditCardNo = data.creditCardNo
      this.mulAcctRcptForm.amountCurrRate = data.amountCurrRate
      this.mulAcctRcptForm.bankAmountCurrRate = data.bankAmountCurrRate
      this.mulAcctRcptForm.actionName = data.actionName
      this.mulAcctRcptForm.bankTotalLocalCurrRate = data.bankTotalLocalCurrRate
      this.mulAcctRcptForm.oldFund = data.oldFund
      this.mulAcctRcptForm.oldAccountNoSuffix = data.oldAccountNoSuffix
      this.mulAcctRcptForm.createdBy = await this.fetchUserDetails(data.createdBy)
      this.mulAcctRcptForm.createdDate = data.createdDate
      this.mulAcctRcptForm.modifiedBy = await this.fetchUserDetails(data.modifiedBy)
      this.mulAcctRcptForm.modifiedDate = data.modifiedDate
    },
    doAccumulate() {
      this.grandTotForm.payment = '0.00'
      this.grandTotForm.gst = '0.00'
      this.grandTotForm.net = '0.00'
      this.grandTotForm.bankAmt = '0.00'
      this.grandTotForm.charges = '0.00'
      this.grandTotForm.total = '0.00'
      this.grandTotForm.localTotal = '0.00'

      for (var i = 0; i < this.accountList.length; i++) {
        this.grandTotForm.payment = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.payment)) + Number(removeFormatNumber(this.accountList[i].amount))
        )
        this.grandTotForm.gst = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.gst)) + Number(removeFormatNumber(this.accountList[i].gstAmount))
        )
        this.grandTotForm.net = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.net)) + Number(removeFormatNumber(this.accountList[i].netAmount))
        )
        this.grandTotForm.bankAmt = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.bankAmt)) + Number(removeFormatNumber(this.accountList[i].bankAmount))
        )
        this.grandTotForm.charges = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.charges)) + Number(removeFormatNumber(this.accountList[i].bankCharges))
        )
        this.grandTotForm.total = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.total)) + Number(removeFormatNumber(this.accountList[i].bankTotalAmount))
        )
        this.grandTotForm.localTotal = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.localTotal)) + Number(removeFormatNumber(this.accountList[i].bankTotalLocal))
        )
      }
    },
    getPaymentMethod(payment) {
      this.getCommonData('paymentmethod', payment)
    },
    doCancel() {
      this.$router.push({ name: 'mulAcctReceipt' })
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, mulAcctReceiptViewMixin, mulAcctReceiptAjaxMixin, commonAjaxMixin, TableConst.default]
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
